import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../redux/authSlice"; 
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
//const SessionTimeout = ({ timeout = 3000 }) => { 
const SessionTimeout = ({ timeout = 57600000 }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loginTime = useSelector((state) => state.auth.loginTime);
  useEffect(() => {
    if (!loginTime) return;
    const currentTime = Date.now();
    const elapsedTime = currentTime - loginTime;
    const remainingTime = timeout - elapsedTime;
    if (remainingTime <= 0) {
      dispatch(logout());
      navigate("/");
      toast.error("Session expired. You have been logged out.", {
        duration: 5000,
        position: "top-center",
        style: {
          fontSize: "16px",
          padding: "12px 20px",
          backgroundColor: "red",
          color: "#fff",
          borderRadius: "8px",
        },
      });
      return;
    }
    const timer = setTimeout(() => {
      dispatch(logout());
      navigate("/");
      toast.error("Session expired. You have been logged out.", {
        duration: 5000,
        position: "top-center",
        style: {
          fontSize: "16px",
          padding: "12px 20px",
          backgroundColor: "red",
          color: "#fff",
          borderRadius: "8px",
        },
      });
    }, remainingTime);

    return () => clearTimeout(timer); 
  }, [dispatch, navigate, loginTime, timeout]);

  return null; 
};

export default SessionTimeout;